import { useState } from 'react'
import clsx from 'clsx'
import { Tooltip } from 'components/Share/Tooltip'
import NotAvailableIcon from 'asset/images/notAvailable.svg'

interface CalendarDateToolTipPops {
  isIconContent?: boolean
  isTextContent?: boolean
  iconType?: 'isClose' | 'isPublic'
  textContent?: string
  tooltipContent: string
  className?: string
  tooltipClassName?: string
  textContentClassName?: string
}

const CalendarDateToolTip = (props: CalendarDateToolTipPops): JSX.Element => {
  const iconImaes = {
    isClose: NotAvailableIcon,
  }

  const [isShowTooltip, setIsShowTooltip] = useState(false)

  return (
    <>
      <div
        className={clsx('icon', props.className)}
        onMouseOver={() => setIsShowTooltip(true)}
        onMouseLeave={() => setIsShowTooltip(false)}
      >
        <Tooltip
          content={props.tooltipContent}
          toggle={isShowTooltip}
          type={'warning'}
          className={props.tooltipClassName}
        />

        {!props.isTextContent && (
          <img src={iconImaes[props.iconType]} className="icon" alt="" />
        )}

        {props.isTextContent && (
          <span className={props.textContentClassName}>
            {props.textContent}
          </span>
        )}
      </div>
    </>
  )
}

export default CalendarDateToolTip
